import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// (optional) import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translations.json";
import ro from "./locales/ro/translations.json";

i18n
  // .use(LanguageDetector) // optional: auto-detect from browser/localStorage
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ro: { translation: ro },
    },
    lng: "ro",          // initial language (override with detector if you use it)
    fallbackLng: "en",
    // react-i18next v12 defaults are fine; set this if you DON'T want Suspense:
    react: { useSuspense: false },
    // security: we don't need escaping in React
    interpolation: { escapeValue: false },
    // persistence (optional if using the detector):
    // detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
